import { inject } from "@angular/core";
import { Router, CanActivateFn } from "@angular/router";
import { AuthService } from "@app/core/services/auth.service";

export const authGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isMockAuthEnabled()) {
    authService.ensureMockSession();
    return true;
  }

  // No token in localStorage -> go straight to login
  if (!authService.getToken()) {
    router.navigate(["/login"]);
    return false;
  }

  // Validate with the SSO portal to confirm it is still valid
  const valid = await authService.validateToken();
  if (!valid) {
    router.navigate(["/login"]);
    return false;
  }

  return true;
};








